import { SituacaoEnum } from '@/utils/enumerados';

/**
 * Contextos de feature do SEL.
 * A view declara o contexto; o orquestrador escolhe o que rodar.
 */
export const FEATURE_CONTEXTS = {
  /** Hero / situação do pregão — tour da fase + hints elegíveis (por situation). */
  'auction.situation': {
    id: 'auction.situation',
    matchBy: 'situation',
  },
  /** Aba Recursos — fila por prioridade (forms → ações → hints). */
  'auction.recursos': {
    id: 'auction.recursos',
  },
  /** Listagem unificada de licitações — fila por capacidade (filtros → criar). */
  'licitacoes.lista': {
    id: 'licitacoes.lista',
  },
  /** Aba ARP (Ata de Registro de Preços) — hub e jornadas de cadastro. */
  'auction.arp': {
    id: 'auction.arp',
  },
};

/** Situações com tour de fase (espelha SituacaoEnum usado nos tours). */
export const SITUACOES_COM_TOUR = [
  SituacaoEnum.AGUARDANDO_INICIO_SESSAO,
  SituacaoEnum.MANIFESTACAO_INTENCAO_RECURSO,
  SituacaoEnum.INTERPOSICAO_DE_RECURSOS,
  SituacaoEnum.ENCERRADA_COM_RECURSO,
];
